var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28123_11842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.375 45.5H26.25V33.25",
    stroke: "#0F5EFF",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24.5V8.75C10.5 8.28587 10.6844 7.84075 11.0126 7.51256C11.3408 7.18437 11.7859 7 12.25 7H33.25L45.5 19.25V24.5",
    stroke: "#0F5EFF",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 7V19.25H45.5",
    stroke: "#0F5EFF",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 33.25L19.25 45.5",
    stroke: "#0F5EFF",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 33.25L10.5 45.5",
    stroke: "#0F5EFF",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.603 33.6C44.603 33.6 38.1652 31.8981 37.6468 36.0063C37.1283 40.1144 46.0533 38.22 45.4736 42.7263C44.9333 46.9175 38.5218 45.1325 38.5218 45.1325",
    stroke: "#0F5EFF",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28123_11842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileXls);
export default __webpack_public_path__ + "static/media/FileXls.7639d0e0107213ff6431519fc8dbebcf.svg";
export { ForwardRef as ReactComponent };